import { connect } from '@souche-f2e/muji';
import { judgeArr } from '@/shared/functions';
const mapStateToProps = (rootState) => {
    return { resources: rootState.global.resources };
};
const AuthorizedNot = ({ resources, allow, notAllow, children }) => {
    let trueAllow = false;
    let trueNotAllow = false;
    if (judgeArr(allow)) {
        trueAllow = allow.every((v) => (resources.includes(v)));
    }
    else {
        trueAllow = !allow || resources.includes(allow);
    }
    if (judgeArr(notAllow)) {
        trueNotAllow = notAllow.every((v) => (!resources.includes(v)));
    }
    else {
        trueNotAllow = !notAllow || !resources.includes(notAllow);
    }
    if (trueAllow && trueNotAllow) {
        return children;
    }
    return null;
};
export default connect(mapStateToProps)(AuthorizedNot);
